import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { GoogleChartsModule } from 'angular-google-charts';
import { TextMaskModule } from 'angular2-text-mask';
import { NgBusyModule } from 'ng-busy';
import { CustomFormsModule } from 'ng2-validation';
import { AlertModule } from '../core/components/alert/alert.module';

import { MinusSignToParensPipe } from './pipes/minus-sign-to-parens.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    AlertModule,
    CommonModule,
    CustomFormsModule,
    FontAwesomeModule,
    FormsModule,
    GoogleChartsModule,
    LayoutModule,
    NgbModule,
    NgSelectModule,
    NgBusyModule,
    ReactiveFormsModule,
    RouterModule,
    TextMaskModule,
    MinusSignToParensPipe,
    SafeHtmlPipe
  ],
  declarations: [
    MinusSignToParensPipe,
    SafeHtmlPipe
  ]
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fab, far, fas);
  }
}
